import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
AuthPermissions.propTypes = {
    allowedRanks: PropTypes.array.isRequired,
    children: PropTypes.any.isRequired,
    currentUserRank: PropTypes.string
};
export default function AuthPermissions(_a) {
    var allowedRanks = _a.allowedRanks, currentUserRankProp = _a.currentUserRank, children = _a.children;
    var currentUserRankFromStore = useSelector(function (state) { return state.userAuthorization.userSession.rank; });
    var currentUserRank = currentUserRankProp !== undefined ? currentUserRankProp : currentUserRankFromStore;
    return allowedRanks && allowedRanks.some(function (rank) { return rank === currentUserRank; }) ? (React.createElement(Fragment, null, children)) : null;
}
